/**
 * Constants file that provides info for the "About" page
 */
export default {
    promoVideoUrl: "https://www.youtube.com/embed/YC_QbhWf3uQ",   
}